import LocationButton from '@components/Map/LocationButton';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import useScript from '@hooks/useScript';
import { useId, useRef, useState } from 'react';

import { MapProps } from '../types';
import useMap from './hooks/useMap';
import useMarkers from './hooks/useMarkers';

function InaviMap({
    center, zoom = 13, width = '100%', markers, onMarkerClick, height, onBoundChange,
    showMyLocation, myLocation,
}:MapProps) {
    const id = useId();
    const mapRef = useRef<inavi.maps.Map>(null);
    const [isMapLoad, setIsMapLoad] = useState<boolean>(false);
    useMap({
        mapRef,
        setIsMapLoad,
        isMapLoad,
        zoom,
        center,
        id,
        onBoundChange,
        showMyLocation,
        myLocation,
    });
    useMarkers({
        mapRef, markers, isMapLoad, onMarkerClick,
    });
    const reCenterMap = () => {
        mapRef.current?.setCenter({ lat: myLocation.lat, lng: myLocation.lng });
    };
    const project = useProject();

    useScript({
        src: `https://imaps.inavi.com/maps/v3.0/appkeys/${project?.mapApiKey}/maps?callback=initMap`,
        enabled: !!project?.mapApiKey,
    });

    return (
        <Wrapper>
            <Container style={{ height, minHeight: height, maxHeight: height }}>
                <div id={id} style={{
                    width,
                    height,
                    minHeight: height,
                    maxHeight: height,
                }}/>
                {(!isMapLoad) && (
                    <SkeletonWrapper >
                        <Skeleton width='100%' height='100%' />
                    </SkeletonWrapper>
                )}
            </Container>
            {showMyLocation && (
                <LocationButton onClick={reCenterMap}/>
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
`;

const Container = styled.div`
    position: relative;
    width: 100%;
`;

const SkeletonWrapper = styled.div`
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2;
`;

export default InaviMap;
